<template>
    <div class="container">
        <v-card-title class="titulopagina">IMPORTAR PRODUCCION DE ACEITE</v-card-title>
        <v-row>
            <v-tabs
            background-color="blue accent-3"
            class="elevation-2"
            dark
            :centered="true"
            :grow="true"
            :vertical="false"
            :right="false"
            prev-icon="mdi-arrow-left-bold-box-outline"
            next-icon="mdi-arrow-right-bold-box-outline"
            :icons-and-text="true"
            >
            <v-tabs-slider></v-tabs-slider>

            <!-- tab importar Excel -->
            <v-tab :href="`#tab-importar-excel`" >
                Importar Datos
                <v-icon>publish</v-icon>
            </v-tab>

            <v-tab-item :value="'tab-importar-excel'" >
                <v-card flat tile >
                    <v-row>
                        <v-col cols="8">
                            <v-card-text color="teal darken-2" class="text-center">Importar Excel Formato Interno</v-card-text>
                            <v-card-text>
                                <v-row>
                                    <v-col>
                                        <v-file-input
                                            id="input_archivo"
                                            @change="cambioArchivo"
                                            v-model="archivo" 
                                            label="Importar Excel desde formato PLP" 
                                            accept=".xlsx, .xls"
                                            outlined 
                                            dense>
                                        </v-file-input>
                                    </v-col>
                                    <v-col>
                                        <v-select
                                            :items="bloques"
                                            item-text="nombre"
                                            item-value="id"
                                            v-model="bloque"
                                            label="Columnas a Importar"
                                            dense
                                        ></v-select>
                                    </v-col>
                                    <v-col>
                                        <v-select
                                            :items="tipos_produccion"
                                            item-text="tipo_produccion"
                                            item-value="id"
                                            v-model="tipo_produccion_id"
                                            label="Tipo de producción"
                                            dense
                                        ></v-select>
                                    </v-col>
                                    <v-col>
                                        <v-btn color="green darken-1"  :dark="!desactivar_importar" :disabled="desactivar_importar" @click="importarDatos"><v-icon>publish</v-icon></v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-text>
                                <alert></alert>
                            </v-card-text>
                        </v-col>
                        <v-col cols="4">
                            <v-card-text color="teal darken-2" class="text-center">Exportar Formato ( Si selecciona un rango de fechas exportará los datos de ese rango) </v-card-text>
                            <v-card-text>
                                <v-row>
                                    <v-col>
                                        <date-picker class="float-right" v-model="fechas" range-separator="|" range placeholder ="Seleccione Rango de Fechas" format="DD-MM-YYYY" :default-value="fechas" valueType="YYYY-MM-DD"></date-picker>
                                    </v-col>
                                    <v-col>
                                        <v-btn color="blue" dark @click="generarFormato"><v-icon>get_app</v-icon></v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-col>
                    
                    </v-row>
                    <hr>
                    <v-row>
                        <v-col cols="6">
                            <v-card-text color="teal darken-2" class="text-center">Importar Excel Formato Sernapesca</v-card-text>
                            <v-card-text>
                                <v-row>
                                    <v-col>
                                        <v-file-input
                                        id="input_archivo2"
                                        @change="cambioArchivo2"
                                        v-model="archivo2" 
                                        label="Importar Producción Formato Sernapesca" 
                                        accept=".xlsx, .xls"
                                        outlined 
                                        dense>
                                        </v-file-input>
                                    </v-col>
                                    <v-col>
                                        <v-btn color="green darken-1"  :dark="!desactivar_importar2" :disabled="desactivar_importar2" @click="importarSernapesca"><v-icon>publish</v-icon></v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-col>
                        <v-col cols="6">
                           <p>Columna C -> Nro Declaración </p>
                           <p>Columna N -> Código Recurso / Producto </p>
                           <p>Columna Q -> Toneladas </p>
                           <p>Columna C -> Nro Declaración </p>
                        </v-col>
                    
                    </v-row>

                </v-card>
            </v-tab-item>
            <!-- tab importar Excel -->

    </v-tabs>
        </v-row>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import Alert from '@/components/shared/Alert.vue';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    data:()=>({
        bloques:[{id:null, nombre:'Seleccione'},{id:1, nombre:'Producción'}, {id:2, nombre:'Despachos'}, {id:3, nombre:'Recepciones'}, {id:4, nombre:'Exportaciones'}],
        tipos_produccion: [],
        tipo_produccion_id: 0,
        bloque:'',
        fecha_inicio:'',
        fecha_fin:'',
        fechas:'',
        select_generar_formato:'',
        select_importar_formato:'',
        archivo:{},
        archivo2:{},
        formatos_aceptados:['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/wps-office.xlsx','application/vnd.ms-excel']
    }),

    mounted() {
        this.cargarTiposProduccion();
    },

    methods: {
        cargarTiposProduccion() {
            this.mostrarLoading({ titulo: 'Cargando tipos de producción...', color: 'blue' });
            const url = `${this.base_url}tipo_produccion`;
            this.axios.get(url, this.headers).then(res => {
                this.tipos_produccion = res.data.data.filter(tp => tp.id > 1);
                this.tipo_produccion_id = this.tipos_produccion[0].id;
                this.ocultarLoading();
            }).catch(error => {
                console.error('error', error);
                this.errorMessage(error, "Error al cargar tipos de producción..");
            });
        },
        cambioArchivo(){
            console.log('archivo',this.archivo);
            if(!this.archivo) {
                return;
            }
            let conf = {};
            // busca entre los formatos aceptados
            var aceptado = this.formatos_aceptados.find(formato => {
                return formato === this.archivo.type;
            });
            
            if(aceptado == undefined){
                /**solo se acepta archivos excel */
                this.archivo = {};
                conf.tipo = "error";
                conf.mensaje = " Formato de archivo no leído. Pruebe a generar el formato y a copiar la información en ese archivo: " + this.archivo.type
                Event.$emit('mostrar_alert',conf);
            } else {
                conf.tipo = "success";
                conf.mensaje = " Tipo de archivo OK "
                Event.$emit('mostrar_alert',conf);
            }
            console.log('aceptado',aceptado);
        },

        cambioArchivo2(){
            console.log('archivo',this.archivo2);
            let conf = {};
            // busca entre los formatos aceptados
            var aceptado = this.formatos_aceptados.find(formato => {
                return formato === this.archivo2.type;
            });
            
            if(aceptado == undefined){
                /**solo se acepta archivos excel */
                this.archivo2 = {};
                conf.tipo = "error";
                conf.mensaje = " Formato de archivo no leído. Pruebe a generar el formato y a copiar la información en ese archivo: " + this.archivo2.type
                Event.$emit('mostrar_alert',conf);
            } else {
                conf.tipo = "success";
                conf.mensaje = " Tipo de archivo OK "
                Event.$emit('mostrar_alert',conf);
            }
            console.log('aceptado',aceptado);
        },

        async generarFormato(){
            let conf = {};
            this.fecha_inicio = this.fechas[0];
            this.fecha_fin = this.fechas[1];
            console.log('generarFormato',this.fecha_inicio,'fecha_fin',this.fecha_fin);
            let url = `${this.base_url}aceites/formato_aceite/${this.fecha_inicio}/${this.fecha_fin}`;
            this.axios.get(url,this.headers).then((res)=>{
                console.log('respuesta formato',res);
                conf.tipo = "success";
                conf.mensaje = " Formato de archivo generado correctamente "
                Event.$emit('mostrar_alert',conf);
                window.location.href = res.data.data;
            }).catch((error)=>{
                console.log('error',error);
                conf.tipo = "error";
                conf.mensaje = error
                Event.$emit('mostrar_alert',conf);
            });
        },

        async importarDatos(){
            //this.mostrarLoading('Subiendo Archivo...');
            this.mostrarLoading({titulo:'Subiendo Archivo...',color:'green'})

            //subiendo el archivo
            let token = this.headers.headers['Authorization'];
            let cabecera = {
                headers:{
                    'Authorization':token,
                    'Content-Type':'multipart/form-data'
                }
            }
            // cabecera['headers']['Content-Type']='multipart/form-data';
            let body = new FormData();
            body.append('archivo', this.archivo);
            body.append('bloque', this.bloque);
            let url = `${this.base_url}aceites/subir_archivo`;
            console.log('headers',cabecera);
            await this.axios.post(url, body, cabecera).then((res) =>{
                this.enviarNombreArchivo(res, 1);
            }).catch((error) =>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },

        async importarSernapesca(){
            //this.mostrarLoading('Subiendo Archivo...');
            this.mostrarLoading({titulo:'Subiendo Archivo...',color:'green'})

            //subiendo el archivo
            let token = this.headers.headers['Authorization'];
            let cabecera = {
                headers:{
                    'Authorization':token,
                    'Content-Type':'multipart/form-data'
                }
            }
            // cabecera['headers']['Content-Type']='multipart/form-data';
            let body = new FormData();
            body.append('archivo', this.archivo2);
            let url = `${this.base_url}aceites/subir_archivo`;
            console.log('headers',cabecera);
            await this.axios.post(url, body, cabecera).then((res) =>{
                this.enviarNombreArchivo(res, 2);
            }).catch((error) =>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },

        async enviarNombreArchivo(res, tipo){
            console.log('cabecerita',this.headers);
            console.log('res archivo',res);
            //this.mostrarLoading('Procesando Datos...');
            this.mostrarLoading({titulo:'Procesando Datos...',color:'green'})
            let url = '';
            if (tipo == 1) {
                url = `${this.base_url}aceites/importar_aceites`;
            } else {
                url = `${this.base_url}aceites/importar_aceite_serna`;
            }
            let body = {    nombre_archivo:res.data.nombre,
                            bloque:this.bloque,
                            tipo_produccion_id: this.tipo_produccion_id,
                        }
            let conf = {};
            //enviando nombre de archivo
            await this.axios.post(url,body,this.headers).then((res)=>{
                console.log('archivo importado',res.data);
                conf.tipo = "success";
                conf.mensaje = res.data.success;
                Event.$emit('mostrar_alert',conf);
                this.limpiar();
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                conf.tipo = "error";
                conf.mensaje = `No se Ha podido importar el archivo`;
                Event.$emit('mostrar_alert',conf);
                this.ocultarLoading();
            });
        },
        limpiar(){
            this.archivo = {};
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        desactivar_importar(){
            if(this.archivo && this.archivo != {}){
                var aceptado = this.formatos_aceptados.find(formato => {
                    return formato === this.archivo.type;
                });
                if((aceptado == undefined) || (!this.bloque)){
                    return true;
                }else{
                    return false;
                }
            }

            return true;
        },
        desactivar_importar2(){
            if(this.archivo2 != {}){
                var aceptado = this.formatos_aceptados.find(formato => {
                return formato === this.archivo2.type;
                });
                if(aceptado == undefined){
                    return true;
                }else{
                    return false;
                }
            }

            return true;
        },
        ...mapState(['base_url','headers'])
    },
    components:{
        'alert':Alert,
        DatePicker
    }
}
</script>